import axios from "axios";
import { SessionStore } from "../../types/store";
import { newAbortSignal } from "../../utils";
import { type ManagementUnit } from "../../types/model/managementUnit";
import { CreateManagementUnitRequest } from "../../types/model/managementUnit";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/management-units`;

export const createEntityManagementUnit = async (
  entityId: number,
  payload: CreateManagementUnitRequest,
): Promise<ManagementUnit> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem("session") || "{}",
  );

  const res = await axios.post<ManagementUnit>(
    `${BASE_URL}/entity/${entityId}`,
    payload,
    {
      headers: {
        "content-type": "application/json",
        "x-access-token": session?.accessToken,
      },
      timeout: Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
      signal:
        AbortSignal.timeout === undefined
          ? newAbortSignal(Number(process.env.REACT_APP_AXIOS_TIME_OUT))
          : AbortSignal.timeout(Number(process.env.REACT_APP_AXIOS_TIME_OUT)),
    },
  );

  return res.data;
};
